import { render, staticRenderFns } from "./DynamicDataTable.vue?vue&type=template&id=89d7f446&"
import script from "./DynamicDataTable.vue?vue&type=script&lang=js&"
export * from "./DynamicDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports